// extracted by mini-css-extract-plugin
export default {"padding_20":"Title_padding_20__oBBZd","cards_container":"Title_cards_container__L88Qd","card_item_rating_text":"Title_card_item_rating_text__0yCet"};